<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <h4 slot="title" class="title">404 Page Not Found!</h4>
    </div>
  </div>
</template>

<script>
export default {};
</script>
